import PropTypes from 'prop-types';

const displayName = 'CheckoutPaid';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
